import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiShare } from 'react-icons/fi';
import PageLayout from '../../components/layout/PageLayout';
import { pageFrameStyle } from '../../components/layout/PageFrame';
import AppUiScope from '../../app-ui/AppUiScope';
import Chevron from '../../components/content/Chevron';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { shareOrCopyUrl } from '../../utils/share';
import { artistSharePath } from './artistPresentation';
import '../../features/browse/Browse.css';
import './ArtistSurface.css';
export default function ArtistShell({ artist, title, full = false, position, children }) {
  const { locale } = useWebLocale(),
    en = locale === 'en',
    navigate = useNavigate();
  const [compact, setCompact] = useState(false),
    [message, setMessage] = useState(''),
    [busy, setBusy] = useState(false),
    sharing = useRef(false),
    mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(() => {
    const read = () => setCompact((old) => window.scrollY > (old ? 52 : 64));
    read();
    window.addEventListener('scroll', read, { passive: true });
    return () => window.removeEventListener('scroll', read);
  }, []);
  const path = artistSharePath(artist);
  const share = async () => {
    if (!path || sharing.current) return;
    sharing.current = true;
    setBusy(true);
    setMessage('');
    try {
      const result = await shareOrCopyUrl({
        url: `https://postpop.kr${path}`,
        title: artist.name,
        text: `${artist.name} — ${en ? 'postpop' : '포스트팝'}`,
      });
      if (mounted.current && result === 'copied')
        setMessage(en ? 'Link copied.' : '링크를 복사했어요.');
    } catch {
      if (mounted.current)
        setMessage(
          en
            ? 'Could not share this artist. Try again.'
            : '아티스트를 공유하지 못했어요. 다시 시도해 주세요.',
        );
    } finally {
      sharing.current = false;
      if (mounted.current) setBusy(false);
    }
  };
  return (
    <AppUiScope className="pp-artist-surface" surface="lists">
      <div
        className={`pp-artist-toolbar${!full && artist?.imageUrl && !compact ? ' is-over-hero' : ''}`}
      >
        <div className="pp-page-frame" style={pageFrameStyle}>
          <button
            aria-label={en ? 'Back' : '뒤로가기'}
            onClick={() => (window.history.state?.idx > 0 ? navigate(-1) : navigate('/search'))}
          >
            <Chevron direction="left" />
          </button>
          <span
            className="pp-artist-toolbar-title"
            role={full ? 'heading' : undefined}
            aria-level={full ? 1 : undefined}
          >
            {full ? title : compact ? artist?.name : ''}
          </span>
          {!full && path ? (
            <button
              aria-label={en ? 'Share artist' : '아티스트 공유'}
              disabled={busy}
              onClick={share}
            >
              <FiShare />
            </button>
          ) : (
            <span />
          )}
        </div>
      </div>
      <PageLayout paddingTop="44px">
        <div className="pp-artist-body" {...position}>
          {message && (
            <p className="pp-artist-message" role="status">
              {message}
            </p>
          )}
          {children}
        </div>
      </PageLayout>
    </AppUiScope>
  );
}
